import React, { useMemo, useState } from 'react';
import { ModuleFilterContext } from './ModuleFilterContext';
import { PageFeedbackContext, PageNotice } from '../PageFeedback';

/** Module layout: heading/metrics, then filters, then the working content. */
export default function PageFrame({ children, className = '', header, metrics, filters, filterModel }) {
  const [target, setTarget] = useState(null);
  const feedback = useMemo(() => ({ target, filterError: filterModel?.error }), [target, filterModel?.error]);
  return (
    <ModuleFilterContext.Provider value={filterModel || null}>
      <PageFeedbackContext.Provider value={feedback}>
      <section className={['wt-page-frame', className].filter(Boolean).join(' ')}>
        {header}
        <div ref={setTarget} className="wt-page-feedback" data-page-section="feedback" />
        {filterModel?.error ? <PageNotice>{filterModel.error}</PageNotice> : null}
        {metrics}
        {filters ? <div className="wt-page-frame__filters" data-page-section="filters">{filters}</div> : null}
        {children}
      </section>
      </PageFeedbackContext.Provider>
    </ModuleFilterContext.Provider>
  );
}
